import { createClient, FunctionsHttpError } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided in environment variables.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// `supabase.functions.invoke` troca o corpo real do erro por uma mensagem
// generica ("Edge Function returned a non-2xx status code") e zera `data`
// sempre que a resposta e non-2xx — o JSON com o motivo real (`{ error,
// codigo }`) so existe em `error.context`, um `Response` ainda nao lido.
// Sem isso, todo erro de Edge Function (400, 409, 500) chega igual na tela.
export async function edgeFunctionErrorBody(
  error: unknown,
): Promise<{ error?: string; codigo?: string } | null> {
  if (!(error instanceof FunctionsHttpError)) return null;
  try {
    return await error.context.json();
  } catch {
    return null;
  }
}
